import { Directive, ElementRef, Input, OnChanges, SimpleChanges, inject } from '@angular/core';

@Directive({
  selector: '[hide]',
})
export class HiddenDirective implements OnChanges {
  private readonly element = inject(ElementRef<any>);

  @Input() hide: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hide) {
      this.element.nativeElement.setAttribute('style', this.hide ? 'display: none !important' : '');
    }
  }
}
